/**
 * Robertson Precision brand assets — supplied artwork, referenced by
 * persistent CDN URL. Do not recolor, crop, distort or animate the mark.
 */
export const BRAND_ASSETS = {
  mark: 'https://cdn.magicpatterns.com/uploads/vDuMBSjqK5AXR4b4oNrPpx/robertson-precision-mark-512.png',
  favicon32:
    'https://cdn.magicpatterns.com/uploads/jDQk81kY2Un57cwUbWzXwi/favicon-32.png',
  appleTouchIcon:
    'https://cdn.magicpatterns.com/uploads/qWBZ9gorYCfaxWUUVa4wYb/apple-touch-icon.png',
  appIcon192:
    'https://cdn.magicpatterns.com/uploads/beEdGDzftgEhcXPEVkmncH/icon-192.png',
  siteThumbnail512:
    'https://cdn.magicpatterns.com/uploads/2sPfPng7HrNds9X2gBuHod/site-thumbnail-512.png',
  ogImage:
    'https://cdn.magicpatterns.com/uploads/39GxNXeidjAVi79UXdnkRk/og-thumbnail-1200x630.png',
}
